export default __webpack_public_path__ + "maps-examples-custom-callout-960-f3e4fd8f8cd2a65d1db78363ff4c8eb5.png";